export default __webpack_public_path__ + "assets/2dc83fe89912352f0ffe7bab0231d24a.png";